import { store } from 'store/index'
import { User } from 'store/modules/users'

export const linkEvent = '$quick_search_click'

export type FilteredUserItem = {
  id: string
  url: string
  title?: string
}

// The items shown when the search narrows down to one person
export const userActionItems = (
  user: User,
  hasActiveSubscription: boolean,
): FilteredUserItem[] => {
  const items: FilteredUserItem[] = [
    {
      id: user.id,
      url: user.profileUrl,
    },
    {
      id: user.id,
      title: `View ${user.isCurrentUser ? 'your' : `${user.fname}'s`} profile`,
      url: user.profileUrl,
    },
  ]

  if (!hasActiveSubscription) return items

  if (user.isCurrentUser) {
    items.push(
      {
        id: user.id,
        title: 'Add a win',
        url: `/wins/new?initialUserId=${user.id}`,
      },
      {
        id: user.id,
        title: 'Add an action',
        url: '/actions/new',
      },
      {
        id: user.id,
        title: 'Start a check-in',
        url: '/checkins/new',
      },
    )

    return items
  }

  items.push({
    id: user.id,
    title: `Add a win for ${user.fname}`,
    url: `/wins/new?initialUserId=${user.id}`,
  })

  const isReport = store.currentUser?.allReports.some(
    (report) => report.id === user.id,
  )

  if (isReport) {
    items.push({
      id: user.id,
      title: `Start a check-in with ${user.fname}`,
      url: `/checkins/new?initialUserId=${user.id}`,
    })
  }

  items.push(
    {
      id: user.id,
      title: `Give feedback to ${user.fname}`,
      url: `/feedback/new?initialUserId=${user.id}`,
    },
    {
      id: user.id,
      title: `Request feedback from ${user.fname}`,
      url: `/feedback-request/new?initialUserId=${user.id}`,
    },
  )

  return items
}
